(function($) {

  'use strict';

  var SCROLL_DOWN_SELECTOR = '.et_pb_fullwidth_header_scroll a';

  if ($(SCROLL_DOWN_SELECTOR).length) {
    $(SCROLL_DOWN_SELECTOR).on('click', function(e) {
      var loggedInOffset = parseInt($('html').css('margin-top'), 10);
      var mastheadHeight = $('.et-l--header').height();
      var nextElementOffset = $(this).closest('.et_pb_section').next().offset().top;

      if (loggedInOffset > 0 && mastheadHeight > 0 && nextElementOffset > 0) {
        e.preventDefault();
        e.stopPropagation();

        $('html, body').animate({
          scrollTop: nextElementOffset - mastheadHeight - loggedInOffset
        }, 1000);
      }
    });
  }

})(jQuery);
